<template>
    <div
            class="images"
            :class="{'images_mobile': $vuetify.breakpoint.xsOnly}"
    >
        <img
                v-for="url in value"
                :src="fileStoreDomain+url"
                class="images__img"
        >
    </div>
</template>

<script>
    export default {
        props: {
            value: {type: Array, default: () => []}
        },
        computed: {
            fileStoreDomain() {
                return process.env.VUE_APP_FILE_STORE_SCHEMA + process.env.VUE_APP_FILE_STORE_DOMAIN;
            }
        }
    }
</script>

<style lang="scss">
    .images {
        width: calc(100% + 8px);
        margin-left: -8px;

        &.images_mobile {
            .images__img {
                max-width: calc(100% - 8px);
                max-height: inherit;
            }
        }
        .images__img {
            max-height: 200px;
            margin: 5px 8px;
        }
    }
</style>